import { render, staticRenderFns } from "./StudentCamera.vue?vue&type=template&id=356f2cce&scoped=true"
import script from "./StudentCamera.vue?vue&type=script&lang=js"
export * from "./StudentCamera.vue?vue&type=script&lang=js"
import style0 from "./StudentCamera.vue?vue&type=style&index=0&id=356f2cce&prod&lang=scss&scoped=true"
import style1 from "./StudentCamera.vue?vue&type=style&index=1&id=356f2cce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f2cce",
  null
  
)

export default component.exports